import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  const contactInfo = [
    {
      icon: '🎥',
      title: 'Google Meet Sessions',
      description: 'Join our live classes and clubs',
      details: 'Available 24/7',
      color: 'from-pink-primary to-red-primary'
    },
    {
      icon: '📧',
      title: 'Email Support',
      description: 'Get help with any questions',
      details: 'oeccorporate@gmail.com',
      color: 'from-red-primary to-yellow-primary'
    },
    {
      icon: '💬',
      title: 'Live Chat',
      description: 'Instant help when you need it',
      details: 'Response within 5 minutes',
      color: 'from-yellow-primary to-pink-primary'
    }
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      icon: '📘',
      url: '#',
      color: 'hover:text-blue-600'
    },
    {
      name: 'Instagram',
      icon: '📸',
      url: '#',
      color: 'hover:text-pink-600'
    },
    {
      name: 'YouTube',
      icon: '📺',
      url: '#',
      color: 'hover:text-red-600'
    },
    {
      name: 'LinkedIn',
      icon: '💼',
      url: '#',
      color: 'hover:text-blue-800'
    },
    {
      name: 'Twitter',
      icon: '🐦',
      url: '#',
      color: 'hover:text-blue-400'
    }
  ];

  const faqs = [
    {
      question: "¿Cómo me uno a una sesión de Google Meet?",
      answer: "Una vez inscrito, recibirás el enlace de Google Meet por correo electrónico antes de cada sesión. Simplemente haz clic en el enlace a la hora programada para unirte."
    },
    {
      question: "¿Puedo probar una lección gratuita primero?",
      answer: "¡Sí! Ofrecemos una clase de prueba gratuita de 30 minutos donde podrás conocer a tu instructor y experimentar nuestro estilo de enseñanza."
    },
    {
      question: "¿Qué pasa si pierdo una clase?",
      answer: "No te preocupes, si no puedes asistir a una de tus clases de la semana, puedes hablar con tu docente para ver la disponibilidad de horario para reponerla, si no hubiese, tu docente volverá a repasar el tema para que no te pierdas de nada y que sea siempre con práctica 100% en vivo."
    }
  ];

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-pink-primary/10 to-yellow-primary/10">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-league-spartan font-bold text-black mb-6">
            Contactanos <span className="text-red-primary">HOY</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-primary mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">
            ¿Listo para empezar tu aprendizaje del inglés? ¡Contáctanos hoy y te ayudaremos a hablar con confianza!
          </p>
          
          <div className="flex justify-center space-x-6">
            <motion.a
              href="https://wa.me/50364376585"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -3 }}
              whileTap={{ scale: 0.9 }}
            >
              <img src="/set/7.png" alt="WhatsApp" className="w-12 h-12" />
            </motion.a>
            <motion.a
              href="https://instagram.com/oec.sv"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -3 }}
              whileTap={{ scale: 0.9 }}
            >
              <img src="/set/8.png" alt="Instagram" className="w-12 h-12" />
            </motion.a>
            <motion.a
              href="https://www.facebook.com/profile.php?id=61580383047370"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -3 }}
              whileTap={{ scale: 0.9 }}
            >
              <img src="/set/9.png" alt="Facebook" className="w-12 h-12" />
            </motion.a>
            <motion.a
              href="mailto:oeccorporate@gmail.com"
              whileHover={{ scale: 1.1, y: -3 }}
              whileTap={{ scale: 0.9 }}
            >
              <img src="/set/10.png" alt="Email" className="w-12 h-12" />
            </motion.a>
            <motion.a
              href="https://tiktok.com/@oec.sv"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -3 }}
              whileTap={{ scale: 0.9 }}
            >
              <img src="/set/11.png" alt="TikTok" className="w-12 h-12" />
            </motion.a>
          </div>
        </motion.div>


        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="bg-white p-8 rounded-2xl shadow-lg max-w-4xl mx-auto">
            <h3 className="text-3xl font-semibold text-black mb-4">
              🚀 ¡Empieza tu prueba gratuita hoy!
            </h3>
            <p className="text-gray-700 mb-8 text-lg">
              Únete a miles de estudiantes que han perfeccionado sus habilidades de inglés con OEC.
              ¡Reserva tu sesión de prueba gratuita de 30 minutos y conoce a tu futuro instructor!
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <motion.a
                href="https://forms.gle/oivQHSULaoNmRmq58"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-primary text-white px-10 py-4 rounded-full font-semibold hover:bg-red-700 transition-colors duration-300 shadow-lg text-lg inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Reserva una prueba gratuita
              </motion.a>
              <span className="text-gray-400">or</span>
              <motion.a
                href="https://forms.gle/GumCo3bkgfktTnMk6"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-red-primary text-red-primary px-8 py-3 rounded-full font-semibold hover:bg-red-primary hover:text-white transition-all duration-300 inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Programar consulta
              </motion.a>
            </div>

            <p className="text-sm text-gray-500 mt-4">
              ✓ No se requiere tarjeta de crédito • ✓ Sesión de 30 minutos • ✓ Conozca a su instructor
            </p>
          </div>
        </motion.div>

        {/* FAQ Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h3 className="text-2xl font-semibold text-black text-center mb-8">
            Preguntas frecuentes
          </h3>
          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white p-6 rounded-lg shadow-md"
              >
                <h4 className="font-semibold text-black mb-2">{faq.question}</h4>
                <p className="text-gray-600">{faq.answer}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Contact;